<template>
	<div class="container">
		<div class="vx-col flex center">
			<UpdateCollaboratorForm v-if="formToLoad === 'collaborator'" />
			<UpdateSocietyForm v-if="formToLoad === 'society'" />
			<UpdateContactForm v-if="formToLoad === 'contact'" />
			<ProspectForm v-if="formToLoad === 'prospect'" :isEdit="true" />
			<UpdateProviderForm v-if="formToLoad === 'providers'" />
			<UpdateContractForm v-if="formToLoad === 'contracts'" />
			<UpdateContractMissionsForm v-if="formToLoad === 'contracts_missions'" />
			<MissionForm v-if="formToLoad === 'missions'" />
			<TaskForm v-if="formToLoad === 'tasks'" />
			<ServiceForm v-if="formToLoad === 'services'" />
			<UpdateProductForm v-if="formToLoad === 'products'" />
			<UpdateNetlinkTypeForm v-if="formToLoad === 'netlink_types'" />
			<UpdatePurchaseForm v-if="formToLoad === 'purchases'" />
		</div>
	</div>
</template>

<script>
import UpdateCollaboratorForm from "@/components/forms/collaborator/UpdateCollaborator";
import UpdateSocietyForm from "@/components/forms/society/UpdateSociety";
import UpdateContactForm from "@/components/forms/contact/UpdateContact";
import UpdateProviderForm from "@/components/forms/provider/UpdateProvider";
import UpdateContractForm from "@/components/forms/contract/UpdateContract";
import ProspectForm from "@/components/forms/prospect/Prospect";
import UpdateContractMissionsForm from "@/components/forms/mission/UpdateContractMissions";
import MissionForm from "@/components/forms/mission/Mission";
import TaskForm from "@/components/forms/task/Task";
import ServiceForm from "@/components/forms/service/Service";
import UpdateProductForm from "@/components/forms/product/UpdateProduct";
import UpdateNetlinkTypeForm from "@/components/forms/netlink/UpdateNetlinkType";
import UpdatePurchaseForm from "@/components/forms/purchase/UpdatePurchase";
import UpdateProspectForm from "@/components/forms/prospect/UpdateProspect";

//////////////////////////////////////////////////////////
//                                                      //
// THIS PAGE HANDLE ALL FORMS FROM THE DASHBOARD PAGES  //
//                                                      //
//////////////////////////////////////////////////////////

export default {
	name: "UpdateEntity",
	formToLoad: "",
	components: {
		UpdateSocietyForm,
		UpdateContactForm,
		UpdateCollaboratorForm,
		UpdateProviderForm,
		UpdateContractForm,
		UpdateContractMissionsForm,
		MissionForm,
		TaskForm,
		ServiceForm,
		ProspectForm,
		UpdateProductForm,
		UpdateNetlinkTypeForm,
		UpdatePurchaseForm,
		UpdateProspectForm,
	},
	created() {
		if (this.$route.params.updateEntityForm) {
			this.formToLoad = this.$route.params.updateEntityForm;
		} else {
			this.formToLoad = sessionStorage.getItem("prevRoute");
		}
	},
	beforeRouteEnter(to, from, next) {
		// Save the previous route name in the session storage
		sessionStorage.setItem("prevRoute", from.name);
		next();
	},
};
</script>

<style scoped>
.center {
	justify-content: center;
}
</style>
